export const CREATE_COA_REQUEST = "CREATE_COA_REQUEST"
export const CREATE_COA_SUCCESS = "CREATE_COA_SUCCESS"
export const CREATE_COA_FAIL = "CREATE_COA_FAIL"
export const CREATE_COA_RESET = "CREATE_COA_RESET"

export const UPDATE_COA_REQUEST = "UPDATE_COA_REQUEST"
export const UPDATE_COA_SUCCESS = "UPDATE_COA_SUCCESS"
export const UPDATE_COA_FAIL = "UPDATE_COA_FAIL"
export const UPDATE_COA_RESET = "UPDATE_COA_RESET"

export const GET_COA_REQUEST = "GET_COA_REQUEST"
export const GET_COA_SUCCESS = "GET_COA_SUCCESS"
export const GET_COA_FAIL = "GET_COA_FAIL"

export const GET_COAs_REQUEST = "GET_COAs_REQUEST"
export const GET_COAs_SUCCESS = "GET_COAs_SUCCESS"
export const GET_COAs_FAIL = "GET_COAs_FAIL"

export const GET_SELECT_PRODUCT_REQUEST = "GET_SELECT_PRODUCT_REQUEST"
export const GET_SELECT_PRODUCT_SUCCESS = "GET_SELECT_PRODUCT_SUCCESS"
export const GET_SELECT_PRODUCT_FAIL = "GET_SELECT_PRODUCT_FAIL"
export const GET_SELECT_PRODUCT_RESET = "GET_SELECT_PRODUCT_RESET"

export const GET_CREATED_BY_REQUEST = "GET_CREATED_BY_REQUEST"
export const GET_CREATED_BY_SUCCESS = "GET_CREATED_BY_SUCCESS"
export const GET_CREATED_BY_FAIL = "GET_CREATED_BY_FAIL"

export const GET_ALL_PRODUCTS_REQUEST = "GET_ALL_PRODUCTS_REQUEST"
export const GET_ALL_PRODUCTS_SUCCESS = "GET_ALL_PRODUCTS_SUCCESS"
export const GET_ALL_PRODUCTS_FAIL = "GET_ALL_PRODUCTS_FAIL"



export const CLEAR_ERROR = "CLEAR_ERROR"